import { render, staticRenderFns } from "./UserDetailsBankDetails.vue?vue&type=template&id=ed4e74a0&"
import script from "./UserDetailsBankDetails.vue?vue&type=script&lang=js&"
export * from "./UserDetailsBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports